// git ignoreされたファイルです。
// 実際のConfigデータはconst.jsに記述してください。
export default Object.freeze({
    prod: false,
    dev: true
});